export { default } from './loading.component';
